import { FormattedMessage } from 'react-intl';
import { Alert } from '@openedx/paragon';
import { AlertBannerProps } from './types';

export const AlertBanner = ({
  onClose,
  variant,
  children,
}: AlertBannerProps) => (
  <Alert
    dismissible
    closeLabel={
      <FormattedMessage
        id="checkout.alert.dismiss"
        defaultMessage="Dismiss"
        description="Dismiss Alert Handler"
      />
    }
    onClose={onClose}
    className="mt-n4 mb-4"
    variant={variant}
  >
    {children}
  </Alert>
);
